<div class="container-fluid inquiry-container">
  <div class="row">
    <div class="col-xxxl-9">
      <div class="d-flex flex-column justify-content-between">
        <base-customer-shift-plan-calendar
          [editInquiryForm]="editInquiryForm"
          class="position-relative"
        ></base-customer-shift-plan-calendar>

        <div class="d-flex flex-row justify-content-between align-items-center py-5">
          <h6 class="m-0">{{ 'inquiry.similarInquiries' | translate }}</h6>
          <base-button
            label="inquiry.showInquiryInfo"
            color="primary"
            class="gap-2 d-flex d-xxxl-none align-items-center"
            (btnClick)="toggleSidebar()"
          ></base-button>
        </div>

        <div class="row">
          <div class="d-flex flex-column justify-content-between gap-3">
            <base-customer-shift-plan-similar-inquiries
              class="inquiry-shift-view-inquiries"
            ></base-customer-shift-plan-similar-inquiries>
            <div
              class="shift-view-action-buttons d-flex flex-row justify-content-end gap-3 position-sticky bottom-0 rounded-4 py-2 ms-auto"
            >
              <base-button
                (btnClick)="saveUnpublishedInquiry()"
                [disabled]="!ranges.length"
                color="dark"
                label="saveRequest"
              ></base-button>
              <base-button
                (btnClick)="publish()"
                *ngIf="canPublishInquiry"
                [disabled]="!ranges.length"
                color="primary"
                label="inquiry.publish"
              ></base-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xxxl-3 d-none d-xxxl-block right-content">
      <base-customer-shift-plan-sidebar
        (hideSidebar)="toggleSidebar()"
        [(submitted)]="isEditInquiryFormSubmitted"
        [inquiryData]="newInquiry"
        [editInquiryForm]="editInquiryForm"
        [isSidebarVisible]="isSidebarVisible"
      ></base-customer-shift-plan-sidebar>
    </div>
  </div>
</div>
